import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { Utils } from '../../Utils/Utils';

var tableId = 'tableRoles';
var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'f><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

export interface IndexPageOptions extends PageOptionsBase {
    urlList: string;
    urlDetail: string;
    localizer: {
        DetailsLink: string;
    }
}

export class IndexPage extends PageBase<IndexPageOptions> {
    private _tableOptions: DatatableOptions;
    private _table: Datatable;

    constructor(options: IndexPageOptions) {
        super(options);

        var getDetailUrl = (rowData: any): string => (`${options.urlDetail}/${rowData.Id}`);

        // === prepare table options
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'Id',
            autoWidth: true,
            columns: [
                {
                    data: "Name",
                    className: "bold",
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkRoleName${rowData.Id}' href='${getDetailUrl(rowData)}'>${data}</a>`)
                },
                {
                    data: 'Membercount',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnMembercount${rowData.Id}'>${data}</span>`)
                },
                {
                    data: 'Description',
                    sortable: false,
                    defaultContent: '',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnDescription${rowData.Id}'>${Utils.valueOrDefault(data, '')}</span>`)
                },
                {
                    data: '',
                    sortable: false,
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkRoleName${rowData.Id}' href='${getDetailUrl(rowData)}'>${options.localizer.DetailsLink}</a>`)
                }
            ]
        };
    }

    init(): void {
        // == create 'new Datatable' instance
        this._table = new Datatable(tableId, this._tableOptions);
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/Roles/IndexPage.ts
 **/